export default __webpack_public_path__ + "static/media/DerekEvans.30c5f6ea.png";